import ProductCard from './product-card';

const selectors = {
  grid: '[data-grid]',
  gridItem: '[data-grid-item]',
  pagination: '[data-pagination]',
  progressViewed: '[data-pagination-viewed]',
  progressBar: '[data-progress-bar]',
  loadMoreButton: '[data-load-more]',
};

function initPagination(sectionID) {
  if (!sectionID) return;

  const grid = document.querySelector(selectors.grid);
  const pagination = document.querySelector(selectors.pagination);

  if (!grid || !pagination) return;

  const settingsData = pagination.dataset.settings || '{}';
  const settings = JSON.parse(settingsData);

  if (settings.type !== 'load-more') {
    return;
  }

  const progressViewedElem = document.querySelector(selectors.progressViewed);
  let productsViewedNo = parseInt(progressViewedElem.textContent, 10);
  const progressBarElem = document.querySelector(selectors.progressBar);

  // Handle click on load more buttons, load next or load previous
  const loadMoreButtons = document.querySelectorAll(selectors.loadMoreButton);
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        loadProducts(button);
      });
    });
  }

  async function loadProducts(button) {
    if (!button) {
      return;
    }

    button.classList.add('btn--loading');

    const isLoadNext = button.hasAttribute('data-load-next');
    const isLoadPrev = button.hasAttribute('data-load-prev');

    const url = button.getAttribute('href');
    const urlToLoad = new URL(url);
    const pageToLoad = parseInt(urlToLoad.searchParams.get('page'), 10);

    urlToLoad.searchParams.set('section_id', sectionID);

    try {
      const response = await fetch(urlToLoad);
      if (response.ok === false) {
        throw new Error('Load more products response was not OK');
      }

      const content = await response.text();

      const parser = new DOMParser();
      const container = parser.parseFromString(content, 'text/html');

      const gridFetched = container.querySelector(selectors.grid);
      const itemsFetched = container.querySelectorAll(selectors.gridItem);

      let newLoadBtn = container.querySelector('[data-load-next]');
      if (isLoadPrev) {
        newLoadBtn = container.querySelector('[data-load-prev]');
      }

      if (itemsFetched.length > 0) {
        itemsFetched.forEach((item) => {
          item.classList.add('is-new');
        });
      }

      if (isLoadNext) {
        grid.insertAdjacentHTML('beforeend', gridFetched.innerHTML);
      } else {
        grid.insertAdjacentHTML('afterbegin', gridFetched.innerHTML);
      }

      const newGridItems = grid.querySelectorAll('.is-new');

      if (newGridItems.length > 0) {
        const newProductCards = grid.querySelectorAll('.is-new .product-card');

        if (newProductCards.length > 0) {
          newProductCards.forEach((product) => {
            ProductCard(product);
          });
        }

        newGridItems.forEach((newGridItem) => {
          newGridItem.classList.remove('is-new');
        });
      }

      history.replaceState({}, '', url);

      button.classList.remove('btn--loading');

      productsViewedNo += itemsFetched.length;

      if (progressViewedElem) {
        progressViewedElem.textContent = productsViewedNo;
      }

      if (progressBarElem) {
        const width = (productsViewedNo * 100) / settings.items_total;
        progressBarElem.style.width = `${width}%`;
      }

      if (isLoadNext && pageToLoad === settings.number_of_pages) {
        button.classList.add('hide');
        return;
      }

      if (isLoadPrev && pageToLoad === 1) {
        pagination.parentNode.classList.add('hide');
        return;
      }

      button.setAttribute('href', newLoadBtn.href);
    } catch (error) {
      window.console.error(error);
    }
  }
}

export default initPagination;
